@if (analytics.enabled && analytics.consent() === "pending") {
  <div class="analytics-consent position-fixed bottom-0 end-0 p-3">
    <section
      class="card shadow mb-0"
      aria-labelledby="analytics-consent-title"
      aria-describedby="analytics-consent-description"
    >
      <div class="card-body">
        <h2 id="analytics-consent-title" class="h6">
          {{ i18n.tr("title") }}
        </h2>
        <p id="analytics-consent-description" class="small">
          {{ i18n.tr("description") }}
        </p>
        <p class="small">
          <a href="https://reazly.com/privacy-policy/" target="_blank" rel="noopener noreferrer">{{ i18n.tr("privacyPolicy") }}</a>
        </p>
        <div class="d-flex flex-wrap gap-2">
          <button
            type="button"
            class="btn btn-primary btn-sm"
            (click)="choose(true)"
          >
            {{ i18n.tr("accept") }}
          </button>
          <button
            type="button"
            class="btn btn-outline-secondary btn-sm"
            (click)="choose(false)"
          >
            {{ i18n.tr("decline") }}
          </button>
        </div>
      </div>
    </section>
  </div>
}
